import { isNil, sortBy } from "lodash";
import { Field, FieldResponse, FieldType, FieldWithPickupOptions, Form, FormResponse } from "types";
import { shouldSkipQuestionnaireModal } from "./Field";

export const TEMP_ID_PREFIX = "question_field";

export const initializeFieldResponse = (field: Field | FieldWithPickupOptions) => {
    const data: FieldResponse = {
        type: field.type,
        label: field.label ?? "",
        roster: field.roster,
        value: field.value ?? "", // Default, but methods can override this
    };

    if (field.unit !== undefined) {
        data.unit = field.unit;
    }

    if (field.summation !== undefined) {
        data.summation = field.summation;
    }

    if (field.optInByDefault !== undefined) {
        data.optInByDefault = field.optInByDefault;
    }

    return data;
};

export const getFields = (form: Form, isPrimary = false, isOrganizerOnly = false) => {
    let fields;

    if (isOrganizerOnly) {
        fields = form.fields.filter((field) => field.organizerOnly);
        return sortBy(fields, "seq");
    }

    if (form.organizerOnly && !isPrimary) {
        return [];
    }

    if (isPrimary) {
        fields = form.fields;
        return sortBy(fields, "seq");
    }

    fields = form.fields.filter((field) => !field.organizerOnly);

    return sortBy(fields, "seq");
};

export const getQuestionnaireFieldCount = (form: Form, isPrimary = false) => {
    if (form.organizerOnly && !isPrimary) {
        return [];
    }

    if (isPrimary) {
        return form.fields.filter((field) => !shouldSkipQuestionnaireModal(field)).length;
    }

    return form.fields.filter((field) => !field.organizerOnly).length;
};

export const hasAddonFieldsInForm = (form: Form) => {
    return form.fields.some((field) => {
        return field.type === FieldType.ADDON;
    });
};

export const hasPickupFieldsInForm = (form: Form) => {
    return form.fields.some((field) => {
        return field.type === FieldType.PICKUP;
    });
};

export const areAllFormFieldsEmpty = (formResponse: FormResponse) => formResponse.fields.every((field) => !field.value);

export const countFilledFields = (formResponse?: FormResponse) => {
    if (!formResponse?.fields) {
        return 0;
    }

    let count = 0;
    for (const field of formResponse.fields) {
        if (!isNil(field?.value) && field.value !== "") {
            count++;
        }
    }

    const { name } = formResponse;
    if (!isNil(name) && name !== "") {
        count++;
    }

    return count;
};
